module.exports = __webpack_public_path__ + "static/media/0.693013f5.jpg";